// Modules
import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

// Components
import { SelectLaboratoryWrapper } from './components'
import { TemplateContainer } from 'redesign/components/templates'

// eslint-disable-next-line prefer-destructuring
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''

export const SelectLaboratory: React.VFC = () => (
    <TemplateContainer renderHeader>
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useEnterprise>
            <SelectLaboratoryWrapper />
        </GoogleReCaptchaProvider>
    </TemplateContainer>
)
